import { Breakpoint } from './breakpoint'

export class Screen extends Breakpoint {
  public gt: Breakpoint = new Breakpoint()
  public lt: Breakpoint = new Breakpoint()
}
